import React from 'react';
import useOrderForm from '../hooks/useOrderForm';
import styles from '../styles/OrderForm.module.css';

const OrderForm = ({ onSubmit, isSubmitting, error }) => {
  const { values, errors, handleChange, handleSubmit } = useOrderForm(onSubmit);

  return (
    <form className={styles.form} onSubmit={handleSubmit} noValidate>
      <div className={styles.fields}>
        <label className={styles.field}>
          <span>Name</span>
          <input
            name="name"
            type="text"
            value={values.name}
            onChange={handleChange}
            autoComplete="name"
            aria-invalid={Boolean(errors.name)}
            aria-describedby={errors.name ? 'order-name-error' : undefined}
          />
          {errors.name && <small id="order-name-error">{errors.name}</small>}
        </label>

        <label className={styles.field}>
          <span>Email</span>
          <input
            name="email"
            type="email"
            value={values.email}
            onChange={handleChange}
            autoComplete="email"
            aria-invalid={Boolean(errors.email)}
            aria-describedby={errors.email ? 'order-email-error' : undefined}
          />
          {errors.email && <small id="order-email-error">{errors.email}</small>}
        </label>

        <label className={styles.field}>
          <span>Phone</span>
          <input
            name="phone"
            type="tel"
            value={values.phone}
            onChange={handleChange}
            autoComplete="tel"
            aria-invalid={Boolean(errors.phone)}
            aria-describedby={errors.phone ? 'order-phone-error' : undefined}
          />
          {errors.phone && <small id="order-phone-error">{errors.phone}</small>}
        </label>

        <label className={styles.field}>
          <span>Collection method</span>
          <select name="fulfillment" value={values.fulfillment} onChange={handleChange}>
            <option value="pickup">Local pickup</option>
            <option value="delivery">Delivery</option>
          </select>
        </label>

        {values.fulfillment === 'delivery' && (
          <label className={styles.field}>
            <span>Delivery address</span>
            <input
              name="address"
              type="text"
              value={values.address}
              onChange={handleChange}
              autoComplete="street-address"
              aria-invalid={Boolean(errors.address)}
              aria-describedby={errors.address ? 'order-address-error' : undefined}
            />
            {errors.address && <small id="order-address-error">{errors.address}</small>}
          </label>
        )}
      </div>

      <label className={`${styles.field} ${styles.notes}`}>
        <span>Order notes</span>
        <textarea
          name="notes"
          value={values.notes}
          onChange={handleChange}
          rows="4"
          placeholder="Tell us anything useful about your order."
        />
      </label>

      {error && <p className={styles.error} role="alert">{error}</p>}

      <button className={styles.submit} type="submit" disabled={isSubmitting}>
        {isSubmitting ? 'Opening secure checkout…' : 'Place order'}
      </button>
    </form>
  );
};

OrderForm.defaultProps = {
  onSubmit: () => {},
  isSubmitting: false,
  error: '',
};

export default OrderForm;
